module.exports = __webpack_public_path__ + "img/scene5-5.df8bd957.png";